import { Box, Button, FormControlLabel, Switch, TextField } from '@mui/material'
import React, { useState } from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup' 
import { useSettings } from '../../../hook/useSettings'



export function AddEditFormSetting(props) {

    const {onRefresh, onClose, setting} = props; 

    const {newSetting, editSetting} = useSettings();

    const formik = useFormik({
        
        initialValues: initialValues(setting),       
        validationSchema: Yup.object(setting ? validationSchemaEdit() : validationSchema()),
        validateOnChange: false,
        
        onSubmit: async (values) =>  {
            try {
            if(setting){
                await editSetting(setting.id, values);
                onRefresh();
                onClose();
            }else{
                await newSetting(values);
                onRefresh();
                onClose();
            }
            
            } catch (error) {
                console.log(error);
            }
            

        },
        
        
    });




return (
    <>
    
    <Box 
            component="form"
            sx={{
                '& > :not(style)': { m: 1, width: '100%' },
            }}
            
            noValidate
            autoComplete="off" 
            onSubmit={formik.handleSubmit}
            >

            <TextField 
            name="name" label="Nombre del Setting" variant="outlined"  
            value={formik.values.name} 
            onChange={formik.handleChange} 
            error={formik.errors.name}           
            /> 
            <TextField 
            name="email" label="Email" variant="outlined"  
            value={formik.values.email} 
            onChange={formik.handleChange} 
            error={formik.errors.email}           
            /> 
            <TextField 
            name="country" label="País" variant="outlined"  
            value={formik.values.country} 
            onChange={formik.handleChange} 
            error={formik.errors.country}           
            /> 
            <TextField 
            name="phone_number" label="Teléfono" variant="outlined"  
            value={formik.values.phone_number} 
            onChange={formik.handleChange} 
            error={formik.errors.phone_number}           
            />            


            <Button type="submit" variant="contained" >
               Guardar
            </Button>
        
        </Box > 
    
    </>
  )
}

function initialValues(data){
    return{
    name: data?.name || "",
    phone_number: data?.phone_number || "",
    country: data?.country || "",    
    email: data?.email || "",
  
    }
}

function validationSchema(){
    return{
        name: Yup.string().required(true),
        phone_number: Yup.string().required(true),
        country: Yup.string().required(true),
        email: Yup.string().required(true)
      
    
    }
}

function validationSchemaEdit(){
    return{
        name: Yup.string().required(true),
        phone_number: Yup.string().required(true),
        country: Yup.string().required(true),
        email: Yup.string().required(true)
        
    }
}